import React, { useCallback } from 'react';
import { useHistory, useParams } from 'react-router';
import { Token } from '../../model/Model';
import { Reporting } from '../common/Reporting';
import { ActionButton } from '../common/ActionButton';
import { useReportState } from '../../state/state';
import { SiteStyle } from '../common/SiteStyle';
import { Logo } from '../common/Logo';
import { Spacer } from '../common/Spacer';
import { LastCheckinSummary } from './LastCheckinSummary';
import { SiteHeader } from '../common/SiteHeader';
import { FetchSiteState } from '../common/FetchSiteState';
import { WhenReady } from '../common/WhenReady';

export const PreviousCheckin = () => {
    const history = useHistory();
    const { token } = useParams<Token>();

    const { reportSuccess, error } = useReportState();

    const onClick = useCallback(() => {
        reportSuccess('');
        history.replace(`/welcome/${token}`);
    }, [reportSuccess, error]);

    return (
        <>
            <FetchSiteState />
            <SiteStyle />
            <Reporting />
            <WhenReady>
                <Spacer height='4rem' />
                <SiteHeader />
                <Spacer height='4rem' />
                <LastCheckinSummary />
                <ActionButton text='Close' onClick={onClick} />
                <Spacer height='4em' />
                <Logo />
            </WhenReady>
        </>
    );
};
